import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'

import TripShareSection from './TripShareSection.vue'
import ShareTokenCard from './ShareTokenCard.vue'
import ShareTokenCardSkeleton from './ShareTokenCardSkeleton.vue'
import NewShareTokenCard from './NewShareTokenCard.vue'
import LButton from '@/components/core/Button.vue'
import { useShareTokensList } from '@/composables/share-token'
import { useSelectedTrip } from '@/composables/trip'
import { logEvent } from '@/utils/utility-manager'


export default /*#__PURE__*/_defineComponent({
  __name: 'TripShareSectionViewOnly',
  setup(__props) {

const trip = useSelectedTrip()
const { data: shareTokens, isLoading } = useShareTokensList(trip.value._id)

const showNewForm = ref(false)

function handleCreateAccessClick() {
  logEvent('trip_share_create_view_only_access_clicked')
  showNewForm.value = true
}

function handleCloseNewForm() {
  showNewForm.value = false
}

return { __sfc: true,trip, shareTokens, isLoading, showNewForm, handleCreateAccessClick, handleCloseNewForm, TripShareSection, ShareTokenCard, ShareTokenCardSkeleton, NewShareTokenCard, LButton }
}

})